import { useMutation, useQueryClient } from '@tanstack/react-query'
import { hoursApi } from '@/entities/working-hours'
import { queryKeys } from '@/shared/api/queryKeys'
import { toast } from '@/shared/model/toast'
import { ApiError } from '@/shared/api/client'
import type { Week } from '@/shared/api/types'

export function useSaveHours() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (week: Week) => hoursApi.save(week),
    onSuccess: (saved) => {
      queryClient.setQueryData(queryKeys.workingHours, saved)
      toast.success('Часы работы сохранены')
    },
    onError: (error) => {
      toast.error(error instanceof ApiError ? error.message : 'Не удалось сохранить')
    },
  })
}
